import React, { FunctionComponent, useEffect } from "react";
import ReactLoading from "react-loading";
import styles from "./Loading.module.css";
import Logo from "../../Assets/Images/head.svg";
// import LogoNew from "../../Assets/Images/ify_logo_new.png";
import LogoNew from "../../Assets/Images/IFY_Magicbricks_Logo.png";
import { connect } from "react-redux";
import { deviceCheck } from "../../Values/utils";

type props = {
  logo?: boolean;
  progress: any;
  theme:any;
  role:any;
  subtext?: boolean;
  fullScreen?: boolean;
};

let mobileFriendlyStyling = {
  loadingParent: {}
};
if (deviceCheck()) {
  mobileFriendlyStyling["loadingParent"] = { minWidth: "0rem" };
}

const Loading: FunctionComponent<props> = ({ logo, progress,theme,role,subtext, fullScreen }) => {

  // useEffect(() => {
  //   // Disable scroll on mount
  //   document.body.style.overflow = 'hidden';

  //   return () => {
  //     // Re-enable scroll on unmount
  //     document.body.style.overflow = '';
  //   };
  // }, []);

  return (
    <div className={styles.parent} style={{ backgroundColor: theme ? "#F5F5F5":"#000000e1",width:"100vw",marginTop: fullScreen ? "0rem": "4rem",zIndex: 10000, ...mobileFriendlyStyling["loadingParent"]}}>
    <ReactLoading
        type={"bars"}
        color={"#279f9f"}
        height={90}
        width={90}
        className={deviceCheck() ? "": styles.loader}
      />
           {subtext && (
        <p
          style={{
            marginTop: "-2rem",
            marginLeft: "-2rem",
            color: "#279f9f",
            fontSize: "1.25rem",
            fontWeight: 700,
          }}
        >
          Please wait, we are processing your data...
        </p>
      )}
      {logo && (
        <img
          src={LogoNew}
          alt={"Logo"}
          style={{ position: "fixed", bottom: 50 }}
        />
      )}
      {progress.total !== 0 && (
        <p
          style={{
            marginTop: "60px",
            color: "#2FA2D3",
            fontSize: "24px",
            fontWeight: 600,
          }}
        >
          {progress.completed} / {progress.total} Completed
        </p>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    progress: state.progress,
    theme: state.theme.isLightMode,
    role: state.user.role,
  };
};

export default connect(mapStateToProps)(Loading);
